import React,{useState, useEffect} from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Navigator from './components/Navigator/index';
import MobileNavigator from './components/Navigator/Mobile';
import Home from './screen/Home/index';
import MobileHome from './screen/Home/Mobile';
import Solution from './screen/Solution/index';
import MobileSolution from './screen/Solution/Mobile';
import MobileService from './screen/Service/Mobile';
import Service from './screen/Service/index';
import AntsTalk from './screen/AntsTalk';
import MobileAntsTalk from './screen/AntsTalk/Mobile';
import Community from './screen/Community';
import MobileCommunity from './screen/Community/Mobile';
import MobileFutureIndustry from './screen/FutureIndustry/Mobile';
import FutureIndustry from './screen/FutureIndustry';
import Footer from './components/Footer';
import Company from './screen/COMPANY/index';
import MobileCompany from './screen/COMPANY/Mobile';
import Business from './screen/Business/index';
import MobileBusiness from './screen/Business/Mobile';
import Contact from './screen/CONTACT/index';
import MobileContact from './screen/CONTACT/Mobile';
import Download from './screen/Download/index';
import MobileDownload from './screen/Download/Mobile';
import DownloadAdmin from './screen/Download/Admin';
import Login from './screen/Login/Login';
import Popup from './components/Popup';
import AdminLayout from './screen/Admin';
import ProtectedAdmin from './screen/Admin/ProtectedAdmin';
import AdminContacts from './screen/Admin/Contacts';
import AdminArchive from './screen/Admin/Archive';
import AdminServerMonitoring from './screen/Admin/ServerMonitoring';
// 헤츠너 클라우드 화면은 뺐다. Hetzner Cloud API 토큰이 있어야 하는데 쓰지
// 않기로 했고, 서버는 이미 SSH 로 다룬다. 파일은 남겨 둔다 — 나중에
// 토큰을 쓰기로 하면 라우트만 다시 붙이면 된다.
import AdminDeploy from './screen/Admin/Deploy';
import AdminDatabaseMonitoring from './screen/Admin/DatabaseMonitoring';
import AdminSystems from './screen/Admin/Systems';
import AdminSlides from './screen/Admin/Slides';
import AdminCatalog from './screen/Admin/Catalog';
import AdminActivityLog from './screen/Admin/ActivityLog';
import AdminUsers from './screen/Admin/Users';
import EnvironmentBadge from './components/EnvironmentBadge';

function App() {
  // 화면 너비 줄어들때 모바일 화면으로 바뀌는것
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 850);
  useEffect(()=>{
      const checkSize =() =>{
          setIsMobile(window.innerWidth <= 850);
      }
      checkSize();

      window.addEventListener('resize', checkSize);

      return()=>{
          window.removeEventListener('resize',checkSize);
      };
    },[]);
    // 팝업 열리고 닫는거
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(()=>{
      setIsPopupOpen(true);
    },[]);

    const closePopup = () =>{
      setIsPopupOpen(false);
    }

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/Admin');

  if (isAdminRoute) {
    return (
      <>
      <EnvironmentBadge />
      <Routes>
        <Route path="/Admin" element={<ProtectedAdmin><AdminLayout/></ProtectedAdmin>}>
          <Route index element={<Navigate to="contacts" replace/>}/>
          <Route path="contacts" element={<AdminContacts/>}/>
          <Route path="archive" element={<AdminArchive/>}/>
          <Route path="server" element={<AdminServerMonitoring/>}/>
          <Route path="deploy" element={<AdminDeploy/>}/>
          <Route path="systems" element={<AdminSystems/>}/>
          <Route path="database" element={<AdminDatabaseMonitoring/>}/>
          <Route path="slides" element={<AdminSlides/>}/>
          <Route path="catalog" element={<AdminCatalog/>}/>
          <Route path="activity" element={<AdminActivityLog/>}/>
          <Route path="users" element={<AdminUsers/>}/>
        </Route>
      </Routes>
      </>
    );
  }

  return (
    <div className="App">
      {/* 개발(.kr / dev.*)에서만 뜬다. 운영에서는 아무것도 그리지 않는다. */}
      <EnvironmentBadge />
      <div className='App-container'>

        <header className="App-header">
          {isMobile ? <MobileNavigator /> : <Navigator />}
        </header>
        <hr style={{ margin:'0rem', border:'1px solid #0F263B' }} width="120%"  />

        <div className='PageContents'>
          <Popup isOpen={isPopupOpen} handleClose={closePopup}/>
          <Routes>
            <Route path="/" element={isMobile ? <MobileHome /> : <Home />} />
            <Route path="/Company" element={isMobile ? <MobileCompany /> : <Company />} />
            <Route path="/Solution" element={isMobile ? <MobileSolution /> : <Solution />} />
            <Route path="/Service" element={isMobile ? <MobileService /> : <Service />} />
            <Route path="/NodeMaster" element={isMobile ? <MobileCommunity /> : <Community />} />
            <Route path="/AntsTalk" element={isMobile ? <MobileAntsTalk /> : <AntsTalk />} />
            <Route path="/Community" element={isMobile ? <MobileCommunity /> : <Community />} />
            <Route path="/FutureIndustry" element={isMobile ? <MobileFutureIndustry /> : <FutureIndustry />} />
            <Route path="/Business" element={isMobile ? <MobileBusiness /> : <Business />} />
            <Route path="/Contact" element={isMobile ? <MobileContact /> : <Contact />} />
            <Route path="/Download" element={isMobile ? <MobileDownload /> : <Download />} />
            <Route path="/Download/Admin" element={<DownloadAdmin />} />
            <Route path="/Login" element={<Login />} />
          </Routes>
          </div>
        <footer>
        <hr style={{ margin: "0rem", border:'1px solid #0F263B' }} width="100%"  />

          <Footer />
        </footer>
      </div>
    </div>
  );
}

export default App;
